module.exports = __webpack_public_path__ + "img/neopagai.346c280e.png";